import type { DigestPeriod } from "../../api/types";

export interface DigestPeriodTabsProps {
  periods: DigestPeriod[];
  selectedKey: string;
  onSelect: (key: string) => void;
}

export function DigestPeriodTabs({ periods, selectedKey, onSelect }: DigestPeriodTabsProps) {
  return (
    <div className="flex flex-wrap gap-2">
      {periods.map((period) => {
        const isSelected = period.period_key === selectedKey;
        return (
          <button
            key={period.period_key}
            type="button"
            onClick={() => onSelect(period.period_key)}
            className={[
              "rounded-full border px-4 py-1.5 text-sm font-medium transition-colors",
              isSelected
                ? "border-brand-600 bg-brand-600 text-white"
                : "border-slate-200 bg-white text-slate-600 hover:border-brand-300 hover:text-brand-700",
            ].join(" ")}
          >
            {period.label}
            {period.is_current ? (
              <span
                className={[
                  "ml-2 rounded-full px-1.5 py-0.5 text-[0.625rem] font-semibold uppercase tracking-wide",
                  isSelected ? "bg-white/20 text-white" : "bg-brand-50 text-brand-700",
                ].join(" ")}
              >
                current
              </span>
            ) : null}
          </button>
        );
      })}
    </div>
  );
}
